<template>
<div @click="selected" :class="icon">
  <radio
    :value="value"
    name="radio"
    :bit="groupName"
  />
  <sprite :name="icon"></sprite>
  {{groupName}}
</div>
</template>

<script>
import Sprite from 'raypro_ui/src/components/ui/Sprite'
import Radio from 'raypro_ui/src/components/ui/inputs/Radio'

export default {
  components: {
    Sprite,
    Radio,
  },

  name: 'compose-message-group-checkbox',

  data() {
    return {
      bit: '',
      group: ''
    }
  },

  props: {
    groupName: {required: true},
    icon: {required: true},
    value: {required: true},
  },

  methods: {
    selected() {
      this.$emit('selectedGroup', this.groupName)
    },
  }
}
</script>

<style lang="sass" scoped>
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'
  @import '../../../stylesheets/helpers/mixins'


  .form-group
    position: relative
    width: 22%
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    margin-bottom: 3%
    padding: 20px
    box-shadow: 0px 2px 8px $color-shadow
    cursor: pointer
    .radio
      position: absolute
      top: 10px
      right: 5px
      margin: 0
      padding: 0
    .sprite
      width: 70px
      height: 70px
    &.surgeon
      .sprite
        fill: $color-primary
    &.nurse
      .sprite
        fill: $color-icon-nurses
    &.hospital
      .sprite
        fill: $color-icon-hospitals
    &.person
      .sprite
        fill: $color-icon-admins
</style>



// WEBPACK FOOTER //
// src/components/pages/Messages/MultipleRadio.vue